import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { healthcareData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function HealthcarePage() {
    return <SolutionTemplate {...healthcareData} />;
}
